<div class="relative">
  <button
    class="relative flex items-center justify-center text-gray-500 transition-colors bg-white border border-gray-200 rounded-full dropdown-toggle hover:text-gray-700 h-11 w-11 hover:bg-gray-100 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
    (click)="toggleDropdown()"
  >
    @if (unreadCount() > 0) {
      <span
        class="absolute -right-1 -top-1 z-10 flex h-5 min-w-5 items-center justify-center rounded-full bg-blue-600 px-1 text-[11px] font-semibold leading-none text-white ring-2 ring-white dark:ring-gray-900"
        [attr.aria-label]="'notifications.dropdown.unreadBadgeAria' | transloco: { count: unreadCount() }"
      >
        {{ unreadCount() > 99 ? '99+' : unreadCount() }}
      </span>
    }
    <svg
      class="fill-current"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.75 2.29248C10.75 1.87827 10.4143 1.54248 10 1.54248C9.58583 1.54248 9.25004 1.87827 9.25004 2.29248V2.83613C6.08266 3.20733 3.62504 5.9004 3.62504 9.16748V14.4591H3.33337C2.91916 14.4591 2.58337 14.7949 2.58337 15.2091C2.58337 15.6234 2.91916 15.9591 3.33337 15.9591H4.37504H15.625H16.6667C17.0809 15.9591 17.4167 15.6234 17.4167 15.2091C17.4167 14.7949 17.0809 14.4591 16.6667 14.4591H16.375V9.16748C16.375 5.9004 13.9174 3.20733 10.75 2.83613V2.29248ZM14.875 14.4591V9.16748C14.875 6.47509 12.6924 4.29248 10 4.29248C7.30765 4.29248 5.12504 6.47509 5.12504 9.16748V14.4591H14.875ZM8.00004 17.7085C8.00004 18.1228 8.33583 18.4585 8.75004 18.4585H11.25C11.6643 18.4585 12 18.1228 12 17.7085C12 17.2943 11.6643 16.9585 11.25 16.9585H8.75004C8.33583 16.9585 8.00004 17.2943 8.00004 17.7085Z"
        fill="currentColor"
      />
    </svg>
  </button>
  <app-dropdown
    [isOpen]="isOpen"
    (close)="closeDropdown()"
    className="notification-dropdown absolute left-1 right-4 mt-4 flex h-auto max-h-[calc(100vh-7rem)] max-w-[350px] w-auto sm:w-[361px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-theme-lg dark:border-gray-800 dark:bg-gray-dark xl:right-0 xl:left-auto"
  >
    <div class="flex items-center justify-between pb-3 mb-3 border-b border-gray-100 shrink-0 dark:border-gray-700">
      <div class="flex items-center gap-2">
        <h5 class="text-lg font-semibold text-gray-800 dark:text-gray-200">
          {{ 'notifications.dropdown.title' | transloco }}
        </h5>
        @if (unreadCount() > 0) {
          <span class="px-2 py-0.5 text-xs font-medium text-white bg-blue-600 rounded-full">
            {{ unreadCount() }}
          </span>
        }
      </div>
      <div class="flex items-center gap-2">
        @if (unreadCount() > 0) {
          <button
            (click)="markAllAsRead()"
            class="text-xs text-blue-600 hover:text-blue-700 dark:text-blue-400"
            [title]="'notifications.dropdown.markAllTitle' | transloco"
          >
            {{ 'notifications.dropdown.markAll' | transloco }}
          </button>
        }
        <button
          (click)="toggleDropdown()"
          class="text-gray-500 transition dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
        >
          <svg
            class="fill-current"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.21967 7.28131C5.92678 6.98841 5.92678 6.51354 6.21967 6.22065C6.51256 5.92775 6.98744 5.92775 7.28033 6.22065L11.999 10.9393L16.7176 6.22078C17.0105 5.92789 17.4854 5.92788 17.7782 6.22078C18.0711 6.51367 18.0711 6.98855 17.7782 7.28144L13.0597 12L17.7782 16.7186C18.0711 17.0115 18.0711 17.4863 17.7782 17.7792C17.4854 18.0721 17.0105 18.0721 16.7176 17.7792L11.999 13.0607L7.28033 17.7794C6.98744 18.0722 6.51256 18.0722 6.21967 17.7794C5.92678 17.4865 5.92678 17.0116 6.21967 16.7187L10.9384 12L6.21967 7.28131Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>
    </div>
    
    <ul
      #scrollContainer
      class="flex flex-col custom-scrollbar"
      [class.flex-1]="expanded()"
      [class.min-h-0]="expanded()"
      [class.overflow-y-auto]="expanded()"
      (scroll)="onScroll($event)"
    >
      @if (notifications().length === 0 && !loading()) {
        <li class="flex items-center justify-center p-8 text-gray-500 dark:text-gray-400">
          <div class="text-center">
            <svg class="w-12 h-12 mx-auto mb-2 text-gray-300 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
            <p class="text-sm">{{ 'notifications.dropdown.empty' | transloco }}</p>
          </div>
        </li>
      }
      
      @for (notification of visibleNotifications(); track notification.id) {
        <li>
          <app-dropdown-item
            (itemClick)="openNotification(notification)"
            [className]="'w-full text-left text-sm flex gap-3 rounded-lg border-b border-gray-100 p-3 px-4.5 py-3 transition-colors cursor-pointer dark:border-gray-800 ' + (notification.isRead ? 'text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-white/5' : 'bg-blue-50 text-gray-800 hover:bg-blue-100 dark:bg-blue-500/10 dark:text-gray-100 dark:hover:bg-blue-500/20')"
          >
            <!-- Avatar con iniciales (azul de marca, como el logo de empresas) -->
            <span class="relative flex items-center justify-center w-10 h-10 rounded-full bg-brand-100 text-brand-600 font-semibold text-sm dark:bg-brand-500/15 dark:text-brand-400">
              {{ getInitialsFromMessage(notification.message) }}
              @if (!notification.isRead) {
                <span class="absolute bottom-0 right-0 z-10 h-2.5 w-full max-w-2.5 rounded-full border-[1.5px] border-white bg-blue-500 dark:border-gray-900"></span>
              }
            </span>
            <span class="block flex-1">
              <p class="mb-2 text-xs text-gray-600 dark:text-gray-400 line-clamp-2" [innerHTML]="formatNotificationMessage(notification.message)"></p>
              <span class="flex items-center gap-2 text-gray-500 text-theme-xs dark:text-gray-400">
                <span>{{ notification.entityType }}</span>
                <span class="w-1 h-1 bg-gray-400 rounded-full"></span>
                <span>{{ getTimeAgo(notification.createdAt) }}</span>
              </span>
            </span>
          </app-dropdown-item>
        </li>
      }

      @if (loading()) {
        <li class="flex items-center justify-center py-4 text-gray-400 dark:text-gray-500">
          <svg class="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
          </svg>
        </li>
      }
    </ul>
    
      @if (showSeeAll()) {
        <button
          type="button"
          (click)="expand()"
          class="block w-full px-4 py-2 mt-3 text-sm font-medium text-center text-gray-700 bg-white border border-gray-300 rounded-lg shrink-0 hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700"
        >
          {{ 'notifications.dropdown.seeAll' | transloco }}
        </button>
      }
    
  </app-dropdown>
</div>